import { TableFilterState, TableSortingState } from '@ibsys/kit';
import { SearchSortItem } from '@/entities/search';

export const tableFilters2Query = (filters: TableFilterState) => {
  let result: Record<string, string | { from?: string | number; to?: string | number } | (string | number)[]> = {};

  filters?.forEach((filter) => {
    if (Array.isArray(filter.value) && filter.value.length) {
      result[filter.id] = filter.value;
    } else if (filter.value !== undefined && filter.value !== null) {
      result[filter.id] = filter.value;
    }
  });

  return result;
};

export const tableSorting2Query = (sorting: TableSortingState) => {
  const result: SearchSortItem[] = [];

  sorting?.forEach((field) => {
    result.push({ field: field.id, direction: field.desc ? 'desc' : 'asc' });
  });

  return result;
};
